import script from "./JSONFormatter.vue?vue&type=script&setup=true&lang=js"
export * from "./JSONFormatter.vue?vue&type=script&setup=true&lang=js"

import "./JSONFormatter.vue?vue&type=style&index=0&id=3782cf34&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3782cf34"]])

export default __exports__